module.exports = __webpack_public_path__ + "img/114.8a5fa6a5.jpg";